import { render } from "./EditOrganisationDailyReportPosition.vue?vue&type=template&id=6bda9e09"
import script from "./EditOrganisationDailyReportPosition.vue?vue&type=script&lang=js"
export * from "./EditOrganisationDailyReportPosition.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__